/**
 * Fellido · Vorher/Nachher
 *
 * Drei Darstellungen: Schieberegler, Nebeneinander, Umschalter.
 * Der Regler zeigt sich beim ersten Sichtbarwerden einmal von selbst —
 * ohne diesen Hinweis ziehen die meisten Besucher gar nicht daran.
 */
class FBeforeAfter extends HTMLElement {
  connectedCallback() {
    this.modus = this.dataset.mode || 'slider';
    this.buehne = this.querySelector('[data-f-ba-stage]');
    this.oben = this.querySelector('[data-f-ba-after]');
    this.griff = this.querySelector('[data-f-ba-handle]');
    this.regler = this.querySelector('[data-f-ba-range]');

    if (this.modus === 'toggle') return this.initUmschalter();
    if (this.modus !== 'slider' || !this.buehne) return;

    this.setze(Number(this.dataset.start || 50));

    this.regler?.addEventListener('input', () => this.setze(Number(this.regler.value)));
    this.buehne.addEventListener('pointerdown', this.onDown);
    this.buehne.addEventListener('pointermove', this.onMove);
    window.addEventListener('pointerup', this.onUp);

    if (this.dataset.demo === 'true') this.demoBeimSichtwerden();
  }

  disconnectedCallback() {
    window.removeEventListener('pointerup', this.onUp);
    this.beobachter?.disconnect();
  }

  setze(prozent) {
    const p = Math.min(100, Math.max(0, prozent));
    this.style.setProperty('--f-ba-pos', `${p}%`);
    if (this.regler && Number(this.regler.value) !== p) this.regler.value = String(p);
    this.griff?.setAttribute('aria-valuenow', String(Math.round(p)));
  }

  ausEvent(event) {
    const r = this.buehne.getBoundingClientRect();
    return ((event.clientX - r.left) / r.width) * 100;
  }

  onDown = (event) => {
    // Nur mit gedrueckter Maustaste ziehen, Beruehrung immer.
    this.zieht = true;
    this.buehne.setPointerCapture?.(event.pointerId);
    this.stoppeDemo();
    this.setze(this.ausEvent(event));
  };

  onMove = (event) => {
    if (!this.zieht) return;
    event.preventDefault();
    this.setze(this.ausEvent(event));
  };

  onUp = () => {
    this.zieht = false;
  };

  /** Einmaliger Schwenk, damit erkennbar wird, dass man ziehen kann. */
  demoBeimSichtwerden() {
    this.beobachter = new IntersectionObserver(
      ([e]) => {
        if (!e.isIntersecting || this.demoGelaufen) return;
        this.demoGelaufen = true;
        this.beobachter.disconnect();
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.laufeDemo();
      },
      { threshold: 0.4 }
    );
    this.beobachter.observe(this);
  }

  laufeDemo() {
    const start = performance.now();
    const von = Number(this.dataset.start || 50);
    const dauer = 2200;
    const schritt = (jetzt) => {
      if (this.demoAus) return;
      const t = Math.min(1, (jetzt - start) / dauer);
      // Hin zum Rand und zurueck, weich abgebremst.
      const welle = Math.sin(t * Math.PI);
      const glatt = welle * welle * (3 - 2 * welle);
      this.setze(von + glatt * (88 - von));
      if (t < 1) this.demoId = requestAnimationFrame(schritt);
    };
    this.demoId = requestAnimationFrame(schritt);
  }

  stoppeDemo() {
    this.demoAus = true;
    if (this.demoId) cancelAnimationFrame(this.demoId);
  }

  initUmschalter() {
    this.knoepfe = [...this.querySelectorAll('[data-f-ba-tab]')];
    this.knoepfe.forEach((b) =>
      b.addEventListener('click', () => {
        this.dataset.show = b.dataset.fBaTab;
        this.knoepfe.forEach((x) => x.setAttribute('aria-selected', String(x === b)));
      })
    );
  }
}

if (!customElements.get('f-before-after')) {
  if (!customElements.get('f-before-after')) customElements.define('f-before-after', FBeforeAfter);
}
